import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79c338d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-container" }
const _hoisted_2 = { class: "loader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinning-bubbles" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bubble-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bubble" })
  ])
], -1))
const _hoisted_4 = { class: "loading-word" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
  text: {
    type: String,
    default: "Loading",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.text), 1)
      ])
    ])
  ]))
}
}

})